<template>
  <div class="pages">
    <!-- 车辆属性信息 -->
    <car-attribute-list ref="carAttributeList" style="margin-bottom: 40px;" :car-type-id.sync="carTypeId" />
    <!-- 当天取消订单规则 -->
    <intraday-cancel ref="intradayCancel" style="margin-bottom: 32px;" :carAttributeFeeConfig="carAttributeFeeConfig"></intraday-cancel>
    <!-- 预约订单取消规则 -->
    <make-an-appointment-cancel ref="makeAnAppointmentCancel" style="margin-bottom: 32px;" :carAttributeFeeConfig="carAttributeFeeConfig"></make-an-appointment-cancel>
    <!-- 预览图片 -->
    <image-preview ref="imagePreview" />
    <car-attribute-details-popup ref="carAttributeDetailsPopup" />
  </div>
</template>

<script>
import { Toast } from "vant";
import carAttributeList from "@/view/driver/cancelOrderRules/components/car-attribute-list.vue";
import intradayCancel from "@/view/driver/cancelOrderRules/components/intraday-cancel.vue";
import makeAnAppointmentCancel from "@/view/driver/cancelOrderRules/components/make-an-appointment-cancel.vue";

import imagePreview from "@/view/driver/cancelOrderRules/components/image-preview.vue";
import carAttributeDetailsPopup from "@/view/driver/cancelOrderRules/components/car-attribute-details-popup.vue";
import {getCarTypeCost} from "@/api/driver/cancelOrderRules/index.js";
export default {
  components:{ 
    carAttributeList ,
    intradayCancel,
    makeAnAppointmentCancel,
    imagePreview ,
    carAttributeDetailsPopup ,
    [Toast.name]:Toast
  },
  data(){
    return {
      carTypeId:null,
      carAttributeFeeConfig:{}
    }
  },
  provide(){
    return {
      imagePreview: options => this.$refs["imagePreview"].show(options),
      carAttributeDetailsPopup : options => this.$refs["carAttributeDetailsPopup"].show(options)
    }
  },
  watch:{
    carTypeId(id){
      if(!id) return false;
      this.getCarTypeCost(id);
    }
  },
  methods:{
    getCarTypeCost(carTypeId){
      this.$toast({
        type:"loading",
        forbidClick:true,
        duration:0,
        message:"加载中"
      });
      return getCarTypeCost(carTypeId).then(({ data }) => {
        if(!data) return false;
        this.carAttributeFeeConfig = data.feeConfig?data.feeConfig:{};
      }).finally(()=>Toast.clear())
    }
  }
}
</script>

<style scoped lang="scss">
  .pages {
    background-color: #FFF;
    padding-bottom: 46px;
  }
  ::v-deep .component {
    padding: 0 12px;
    .component-title {
      font-size: 16px;
      color: #EC892E;
      line-height: 32px;
      padding-left: 7px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 8px;
        top: 8px;
        z-index: 1;
        width: 3px;
        border-radius: 1px;
        background-color: #EC892E;
      }
    }
    .flex-sb {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>